import { AbstractControl } from '@angular/forms';
import { isObservable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { FieldModel } from '../../services/actions/models/field.model';

export interface Data {
  fields: { name: string; value: string | string[] }[];
}

const setFormData = (fieldModels: FieldModel[], data: Data): void => {
  fieldModels.forEach((fieldModel: FieldModel) => {
    if (fieldModel) {
      fieldModel.formControl.markAsTouched();
      const valueObj: any = data.fields.find((elem: any) => elem.name === fieldModel.key);
      const fieldData = fieldModel.settings.data;
      let value = null;

      if (valueObj && valueObj.value !== null && valueObj.value !== undefined) {
        value = valueObj && valueObj.value;
        if (Array.isArray(value) && fieldData && !isObservable(fieldData)) {
          value = value.filter((item) => {
            switch (true) {
              case !!item?.id:
                return fieldData[item.id];
              default:
                return fieldData[item];
            }
          });
        }
      }

      if (value || value === 0 || value === false) {
        fieldModel.formControl.setValue(value);
      }
    }
  });
};

const setFirstSelectValueByDefault = (fieldModels: FieldModel[]): void => {
  fieldModels.forEach((fieldModel: FieldModel) => {
    if (fieldModel) {
      let formControlRequired: boolean;

      try {
        formControlRequired = fieldModel.formControl.validator({} as AbstractControl).required ?? false;
      } catch {}

      if (formControlRequired && !fieldModel.formControl.value) {
        if (isObservable(fieldModel.settings.data)) {
          setFirstSelectValueAsync(fieldModel);
        } else {
          setFirstSelectValue(fieldModel);
        }
      }
    }
  });
};

function setFirstSelectValue(fieldModel: FieldModel): void {
  const TRUE_TYPES = ['status', 'is_active'];
  const FALSE_TYPES = ['archived', 'default'];

  let value: string | string[] | number;
  const selectData = Object.keys(fieldModel?.settings?.data || {})[0];

  switch (true) {
    case fieldModel.key === 'included_countries':
    case fieldModel.key === 'excluded_countries':
      break;
    case TRUE_TYPES.some((type) => type === fieldModel.key):
      value = 1;
      break;
    case FALSE_TYPES.some((type) => type === fieldModel.key):
      value = 0;
      break;
    case !!selectData:
      value = fieldModel.settings?.multiple ? [selectData] : selectData;
      break;
  }

  if (!fieldModel.settings?.multiple) {
    setTimeout(() => {
      fieldModel.formControl.setValue(value);
    }, 0);
  }
}

function setFirstSelectValueAsync(fieldModel: FieldModel): void {
  fieldModel.settings.data
    .pipe(
      take(1),
      map((values) => Object.keys(values)[0])
    )
    .subscribe((value) => {
      if (!fieldModel.settings?.multiple) {
        fieldModel.formControl.setValue(value);
      }
    });
}

export { setFormData, setFirstSelectValueByDefault };
